export const LOCATION_DETAILS_FORM_ID = 'location-details-form'
